import React from "react";
import { useOutlet } from "react-router";

export const LibraryConfiguration = () => {
  const outlet = useOutlet();
  return <>{outlet || <h4>Import library content</h4>}</>;
};
